module.exports = __webpack_public_path__ + "media/icons/expand-width-1fba2e2e.svg";